import { useDetailApi } from "../../../swr/useApi";
import { adminPaymentsService } from "../data/admin-payments.service";
import type { PaymentDto } from "../data/types";

export function useAdminPayment(id: number | undefined) {
  return useDetailApi<PaymentDto>({
    key: id ? `admin-payment-${id}` : null,
    serviceMethod: async () => adminPaymentsService.getPayment(id!),
  });
}
